
import "../css/global.css?modules=false";

import "../css/index.css?modules=false";
import "../css/layout.css?modules=false";
import "../css/dark-theme.css?modules=false";
import "../css/light-theme.css?modules=false";

import { getItem } from 'utils';

let productStylesheet = getItem("stylesheet");

if (productStylesheet && productStylesheet !== null) {
  productStylesheet = productStylesheet;

  let innerStyle = ":root {";

  Object.keys(productStylesheet).forEach((element) => {
    if (element.split("-")[0] === "image") {
      innerStyle = innerStyle.concat(
        `--${element}: url(${productStylesheet[element]}); `
      );
    } else {
      innerStyle = innerStyle.concat(
        `--${element}: ${productStylesheet[element]}; `
      );
    }
  });

  innerStyle = innerStyle.concat("}");

  let newStyles = document.createElement("style");
  document.head.append(newStyles);

  newStyles.innerHTML = innerStyle;
}
